/**
 * Name shown in the discovery table for a row. Iris rows prefer the registry
 * make/model (what HIL and operators match on) and fall back to the advertised
 * mDNS instance when the catalog does not know the TXT modelID.
 */
export const irisRowDisplayName = (
  connection: string,
  advertisedName: string,
  registryMakeAndModel?: string
): string => {
  if (connection === 'Iris' && registryMakeAndModel && registryMakeAndModel !== 'Unknown') {
    return registryMakeAndModel;
  }
  return advertisedName;
};
